import { KeyOutlined, EditOutlined, LockOutlined } from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useLoginPoolContext } from '_/contexts/LoginPoolContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const keyIcon = <KeyOutlined />;
const editIcon = <EditOutlined />;
const lockIcon = <LockOutlined />;

export function useLoginPoolSidebarItems(): SidebarItem[] {
  const { selectedOrgSlug } = useOrganization();
  const { selectedProjectSlug } = useProject();
  const { selectedLoginPoolSlug } = useLoginPoolContext();

  return useMemo(() => {
    // If we're on the new page or list page, show link back to login pools
    if (!selectedLoginPoolSlug || selectedLoginPoolSlug === '_new') {
      return [
        {
          icon: keyIcon,
          text: 'Login Pools',
          href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/loginpools`,
        },
      ];
    }

    // For a specific login pool, show its menu items
    const items: SidebarItem[] = [
      {
        icon: editIcon,
        text: 'Edit login pool',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/loginpools/${selectedLoginPoolSlug}`,
      },
      {
        icon: lockIcon,
        text: 'Logins',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/loginpools/${selectedLoginPoolSlug}/logins`,
      },
    ];

    return items;
  }, [selectedOrgSlug, selectedProjectSlug, selectedLoginPoolSlug]);
}
